<template>
  <MTableCell>
    <div
      class="m-table-cell-text text text--xs"
      :style="{color: textColor}"
    >
      <span>{{ itemText }}</span>
    </div>
  </MTableCell>
</template>

<script>
  import {mTableCells} from '@marilyn/marilyn-ui';

  export default {
    name: 'MTableCellText',
    components: {
      MTableCell: mTableCells.MTableCell
    },
    props: {
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      },
      textColor: {type: String, default: '#242424'}
    },
    computed: {
      itemText () {
        return this.tableRow[this.itemKey] ?? '—';
      }
    }
  };
</script>
